import styled from 'styled-components';

export const STDStyle = styled.div`
 margin-top: 150px;
 display: flex;
 justify-content: center;
`;
export const Buttons = styled.div`
  width: 100%;
  display: flex;
  margin-top: 30px;
  justify-content: center;
`;
export const BoxInput = styled.div`
  width: 100%;
  max-width: 450px;
  display: flex;
  margin-top: 30px;
  gap: 30px;
  flex-direction: column;
`;
